import React from "react";
import { useSearchParams } from "react-router-dom";
import PlacementRequestForm from "@/components/PlacementRequestForm";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PlacementHelp() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const ref = params.get("ref") || "";
  return (
    <div data-testid="placement-help-page" className="bg-background">
      <section className="mx-auto max-w-4xl px-6 py-16 lg:px-8">
        <p className="text-sm uppercase tracking-[0.18em] text-primary">
          <Sparkles className="mb-1 mr-1 inline h-3.5 w-3.5" /> Personalized placement advisor
        </p>
        <h1 className="mt-2 font-serif text-5xl leading-[1.05] text-forest sm:text-6xl">
          Looking for a permanent home for Mom or Dad?
        </h1>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-muted-foreground">
          When you're ready to think about a permanent placement — memory care, assisted living, or
          a small group home — a Providence Partners advisor will guide you personally. We know the
          homes, we know the families, and we'll match you with options that fit your budget,
          location, and your loved one's care needs.
        </p>
        <p className="mt-3 max-w-2xl text-base italic text-gold">
          No facility tours are auto-scheduled here — every introduction is made by a human advisor.
        </p>

        <div className="mt-8 flex flex-wrap items-center gap-3 rounded-2xl border border-gold/40 bg-gold/5 p-5" data-testid="placement-phone-cta">
          <Phone className="h-6 w-6 text-gold" strokeWidth={1.5} />
          <div className="flex-1">
            <p className="font-serif text-lg text-forest">Prefer to call?</p>
            <p className="text-sm text-muted-foreground">Talk to an advisor right now — same-day callback most weekdays.</p>
          </div>
          <Button asChild className="rounded-full bg-primary px-6 py-5 text-base text-primary-foreground" data-testid="placement-call-btn">
            <a href="tel:+15863068449"><Phone className="mr-2 h-4 w-4" /> (586) 306-8449</a>
          </Button>
        </div>
        <p className="-mt-1 text-right text-xs italic text-muted-foreground" data-testid="placement-call-availability">Always available — 24/7</p>

        <div className="mt-10">
          <p className="mb-3 text-sm uppercase tracking-wider text-muted-foreground">Or fill out this short form</p>
          <PlacementRequestForm
            defaultContact={user ? { name: user.name, email: user.email, phone: user.phone } : {}}
            hideContactFields={!!user}
            referralSource={ref}
          />
        </div>
      </section>
    </div>
  );
}
